module.exports = __webpack_public_path__ + "static/media/img-footernav--guidebook.282d81fc.png";